import Swal from "sweetalert2"

const Popup = (title = "", content = "", then = null) => {
    Swal.fire(
        title,
        content,
        'success'
    ).then(then)
}

export default Popup
